function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableclipboard
 */
import { Plugin } from 'ckeditor5/src/core';
import TableSelection from './tableselection';
import TableWalker from './tablewalker';
import TableUtils from './tableutils';
import { getColumnIndexes, getRowIndexes, getSelectionAffectedTableCells, isSelectionRectangular, sortRanges } from './utils/selection';
import { cropTableToDimensions, getHorizontallyOverlappingCells, getVerticallyOverlappingCells, removeEmptyRowsColumns, splitHorizontally, splitVertically, trimTableCellIfNeeded, adjustLastRowIndex, adjustLastColumnIndex } from './utils/structure';
/**
 * This plugin adds support for copying/cutting/pasting fragments of tables.
 * It is loaded automatically by the {@link module:table/table~Table} plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableClipboard = /*#__PURE__*/function (_Plugin) {
  _inherits(TableClipboard, _Plugin);

  var _super = _createSuper(TableClipboard);

  function TableClipboard() {
    _classCallCheck(this, TableClipboard);

    return _super.apply(this, arguments);
  }

  _createClass(TableClipboard, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var viewDocument = editor.editing.view.document;
      this.listenTo(viewDocument, 'copy', function (evt, data) {
        return _this._onCopyCut(evt, data);
      });
      this.listenTo(viewDocument, 'cut', function (evt, data) {
        return _this._onCopyCut(evt, data);
      });
      this.listenTo(editor.model, 'insertContent', function (evt, args) {
        return _this._onInsertContent.apply(_this, [evt].concat(_toConsumableArray(args)));
      }, {
        priority: 'high'
      });
      this.decorate('_replaceTableSlotCell');
    }
    /**
     * Copies table content to a clipboard on "copy" & "cut" events.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} evt An object containing information about the handled event.
     * @param {Object} data Clipboard event data.
     */

  }, {
    key: "_onCopyCut",
    value: function _onCopyCut(evt, data) {
      var tableSelection = this.editor.plugins.get(TableSelection);

      if (!tableSelection.getSelectedTableCells()) {
        return;
      }

      if (evt.name == 'cut' && this.editor.isReadOnly) {
        return;
      }

      data.preventDefault();
      evt.stop();
      var dataController = this.editor.data;
      var viewDocument = this.editor.editing.view.document;
      var content = dataController.toView(tableSelection.getSelectionAsFragment());
      viewDocument.fire('clipboardOutput', {
        dataTransfer: data.dataTransfer,
        content: content,
        method: evt.name
      });
    }
    /**
     * Overrides default {@link module:engine/model/model~Model#insertContent `model.insertContent()`} method to handle pasting table inside
     * selected table fragment.
     *
     * Depending on selected table fragment:
     * - If a selected table fragment is smaller than paste table it will crop pasted table to match dimensions.
     * - If dimensions are equal it will replace selected table fragment with a pasted table contents.
     *
     * @private
     * @param evt
     * @param {module:engine/model/documentfragment~DocumentFragment|module:engine/model/item~Item} content The content to insert.
     * @param {module:engine/model/selection~Selectable} [selectable=model.document.selection]
     * The selection into which the content should be inserted. If not provided the current model document selection will be used.
     */

  }, {
    key: "_onInsertContent",
    value: function _onInsertContent(evt, content, selectable) {
      var _this2 = this;

      if (selectable && !selectable.is('documentSelection')) {
        return;
      }

      var model = this.editor.model;
      var tableUtils = this.editor.plugins.get(TableUtils); // We might need to crop table before inserting so reference might change.

      var pastedTable = getTableIfOnlyTableInContent(content, model);

      if (!pastedTable) {
        return;
      }

      var selectedTableCells = getSelectionAffectedTableCells(model.document.selection);

      if (!selectedTableCells.length) {
        removeEmptyRowsColumns(pastedTable, tableUtils);
        return;
      } // Override default model.insertContent() handling at this point.


      evt.stop();
      model.change(function (writer) {
        var pastedDimensions = {
          width: tableUtils.getColumns(pastedTable),
          height: tableUtils.getRows(pastedTable)
        }; // Prepare the table for pasting.

        var selection = prepareTableForPasting(selectedTableCells, pastedDimensions, writer, tableUtils); // Beyond this point we operate on a fixed content table with rectangular selection and proper last row/column values.

        var selectionHeight = selection.lastRow - selection.firstRow + 1;
        var selectionWidth = selection.lastColumn - selection.firstColumn + 1; // Crop pasted table if:
        // - Pasted table dimensions exceeds selection area.
        // - Pasted table has broken layout (ie some cells sticks out by the table dimensions established by the first and last row).
        //
        // Note: The table dimensions are established by the width of the first row and the total number of rows.
        // It is possible to programmatically create a table that has rows which would have cells anchored beyond first row width but
        // such table will not be created by other editing solutions.

        var cropDimensions = {
          startRow: 0,
          startColumn: 0,
          endRow: Math.min(selectionHeight, pastedDimensions.height) - 1,
          endColumn: Math.min(selectionWidth, pastedDimensions.width) - 1
        };
        pastedTable = cropTableToDimensions(pastedTable, cropDimensions, writer); // Content table to which we insert a pasted table.

        var selectedTable = selectedTableCells[0].findAncestor('table');

        var cellsToSelect = _this2._replaceSelectedCellsWithPasted(pastedTable, pastedDimensions, selectedTable, selection, writer);

        if (_this2.editor.plugins.get('TableSelection').isEnabled) {
          // Selection ranges must be sorted because the first and last selection ranges are considered
          // as anchor/focus cell ranges for multi-cell selection.
          var selectionRanges = sortRanges(cellsToSelect.map(function (cell) {
            return writer.createRangeOn(cell);
          }));
          writer.setSelection(selectionRanges);
        } else {
          // Set selection inside first cell if multi-cell selection is disabled.
          writer.setSelection(cellsToSelect[0], 0);
        }
      });
    }
    /**
     * Replaces the part of selectedTable with pastedTable.
     *
     * @private
     * @param {module:engine/model/element~Element} pastedTable
     * @param {Object} pastedDimensions
     * @param {Number} pastedDimensions.height
     * @param {Number} pastedDimensions.width
     * @param {module:engine/model/element~Element} selectedTable
     * @param {Object} selection
     * @param {Number} selection.firstColumn
     * @param {Number} selection.firstRow
     * @param {Number} selection.lastColumn
     * @param {Number} selection.lastRow
     * @param {module:engine/model/writer~Writer} writer
     * @returns {Array.<module:engine/model/element~Element>}
     */

  }, {
    key: "_replaceSelectedCellsWithPasted",
    value: function _replaceSelectedCellsWithPasted(pastedTable, pastedDimensions, selectedTable, selection, writer) {
      var pastedWidth = pastedDimensions.width,
          pastedHeight = pastedDimensions.height; // Holds two-dimensional array that is addressed by [ row ][ column ] that stores cells anchored at given location.

      var pastedTableLocationMap = createLocationMap(pastedTable, pastedWidth, pastedHeight);

      var selectedTableMap = _toConsumableArray(new TableWalker(selectedTable, {
        startRow: selection.firstRow,
        endRow: selection.lastRow,
        startColumn: selection.firstColumn,
        endColumn: selection.lastColumn,
        includeAllSlots: true
      })); // Selection must be set to pasted cells (some might be removed or new created).


      var cellsToSelect = []; // Store next cell insert position.

      var insertPosition; // Content table replace cells algorithm iterates over a selected table fragment and:
      //
      // - Removes existing table cells at current slot (location).
      // - Inserts cell from a pasted table for a matched slots.
      //
      // This ensures proper table geometry after the paste

      var _iterator = _createForOfIteratorHelper(selectedTableMap),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tableSlot = _step.value;
          var row = tableSlot.row,
              column = tableSlot.column; // Save the insert position for current row start.

          if (column === selection.firstColumn) {
            insertPosition = tableSlot.getPositionBefore();
          } // Map current table slot location to an pasted table slot location.


          var pastedRow = row - selection.firstRow;
          var pastedColumn = column - selection.firstColumn;
          var pastedCell = pastedTableLocationMap[pastedRow % pastedHeight][pastedColumn % pastedWidth]; // Clone cell to insert (to duplicate its attributes and children).
          // Cloning is required to support repeating pasted table content when inserting to a bigger selection.

          var cellToInsert = pastedCell ? writer.cloneElement(pastedCell) : null; // Replace the cell from the current slot with new table cell.

          var newTableCell = this._replaceTableSlotCell(tableSlot, cellToInsert, insertPosition, writer); // The cell was only removed.


          if (!newTableCell) {
            continue;
          } // Trim the cell if it's row/col-spans would exceed selection area.


          trimTableCellIfNeeded(newTableCell, row, column, selection.lastRow, selection.lastColumn, writer);
          cellsToSelect.push(newTableCell);
          insertPosition = writer.createPositionAfter(newTableCell);
        } // If there are any headings, all the cells that overlap from heading must be splitted.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var headingRows = parseInt(selectedTable.getAttribute('headingRows') || 0);
      var headingColumns = parseInt(selectedTable.getAttribute('headingColumns') || 0);
      var areHeadingRowsIntersectingSelection = selection.firstRow < headingRows && headingRows <= selection.lastRow;
      var areHeadingColumnsIntersectingSelection = selection.firstColumn < headingColumns && headingColumns <= selection.lastColumn;

      if (areHeadingRowsIntersectingSelection) {
        var columnsLimit = {
          first: selection.firstColumn,
          last: selection.lastColumn
        };
        var newCells = doHorizontalSplit(selectedTable, headingRows, columnsLimit, writer, selection.firstRow);
        cellsToSelect.push.apply(cellsToSelect, _toConsumableArray(newCells));
      }

      if (areHeadingColumnsIntersectingSelection) {
        var rowsLimit = {
          first: selection.firstRow,
          last: selection.lastRow
        };

        var _newCells = doVerticalSplit(selectedTable, headingColumns, rowsLimit, writer);

        cellsToSelect.push.apply(cellsToSelect, _toConsumableArray(_newCells));
      }

      return cellsToSelect;
    }
    /**
     * Replaces a single table slot.
     *
     * @private
     * @param {module:table/tablewalker~TableSlot} tableSlot
     * @param {module:engine/model/element~Element} cellToInsert
     * @param {module:engine/model/position~Position} insertPosition
     * @param {module:engine/model/writer~Writer} writer
     * @returns {module:engine/model/element~Element|null} Inserted table cell or null if slot should remain empty.
     */

  }, {
    key: "_replaceTableSlotCell",
    value: function _replaceTableSlotCell(tableSlot, cellToInsert, insertPosition, writer) {
      var cell = tableSlot.cell,
          isAnchor = tableSlot.isAnchor; // If the slot is occupied by a cell in a selected table - remove it.
      // The slot of this cell will be either:
      // - Replaced by a pasted table cell.
      // - Spanned by a previously pasted table cell.

      if (isAnchor) {
        writer.remove(cell);
      } // There is no cell to insert (might be spanned by other cell in a pasted table) - advance to the next content table slot.


      if (!cellToInsert) {
        return null;
      }

      writer.insert(cellToInsert, insertPosition);
      return cellToInsert;
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableClipboard';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableSelection, TableUtils];
    }
  }]);

  return TableClipboard;
}(Plugin);
/**
 * Extract table for pasting into table.
 *
 * @private
 * @param {module:engine/model/documentfragment~DocumentFragment|module:engine/model/item~Item} content The content to insert.
 * @param {module:engine/model/model~Model} model The editor model.
 * @returns {module:engine/model/element~Element|null}
 */


export { TableClipboard as default };
export function getTableIfOnlyTableInContent(content, model) {
  if (!content.is('documentFragment') && !content.is('element')) {
    return null;
  } // Table passed directly.


  if (content.is('element', 'table')) {
    return content;
  } // We do not support mixed content when pasting table into table.
  // See: https://github.com/ckeditor/ckeditor5/issues/6817.


  if (content.childCount == 1 && content.getChild(0).is('element', 'table')) {
    return content.getChild(0);
  } // If there are only whitespaces around a table then use that table for pasting.


  var contentRange = model.createRangeIn(content);

  var _iterator2 = _createForOfIteratorHelper(contentRange.getItems()),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var element = _step2.value;

      if (element.is('element', 'table')) {
        // Stop checking if there is some content before table.
        var rangeBefore = model.createRange(contentRange.start, model.createPositionBefore(element));

        if (model.hasContent(rangeBefore, {
          ignoreWhitespaces: true
        })) {
          return null;
        } // Stop checking if there is some content after table.


        var rangeAfter = model.createRange(model.createPositionAfter(element), contentRange.end);

        if (model.hasContent(rangeAfter, {
          ignoreWhitespaces: true
        })) {
          return null;
        } // There wasn't any content neither before nor after.


        return element;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return null;
} // Prepares a table for pasting and returns adjusted selection dimensions.
//
// @param {Array.<module:engine/model/element~Element>} selectedTableCells
// @param {Object} pastedDimensions
// @param {Number} pastedDimensions.height
// @param {Number} pastedDimensions.width
// @param {module:engine/model/writer~Writer} writer
// @param {module:table/tableutils~TableUtils} tableUtils
// @returns {Object} selection
// @returns {Number} selection.firstColumn
// @returns {Number} selection.firstRow
// @returns {Number} selection.lastColumn
// @returns {Number} selection.lastRow

function prepareTableForPasting(selectedTableCells, pastedDimensions, writer, tableUtils) {
  var selectedTable = selectedTableCells[0].findAncestor('table');
  var columnIndexes = getColumnIndexes(selectedTableCells);
  var rowIndexes = getRowIndexes(selectedTableCells);
  var selection = {
    firstColumn: columnIndexes.first,
    lastColumn: columnIndexes.last,
    firstRow: rowIndexes.first,
    lastRow: rowIndexes.last
  }; // Single cell selected - expand selection to pasted table dimensions.

  var shouldExpandSelection = selectedTableCells.length === 1;

  if (shouldExpandSelection) {
    selection.lastRow += pastedDimensions.height - 1;
    selection.lastColumn += pastedDimensions.width - 1;
    expandTableSize(selectedTable, selection.lastRow + 1, selection.lastColumn + 1, tableUtils);
  } // In case of expanding selection we do not reset the selection so in this case we will always try to fix selection
  // like in the case of a non-rectangular area. This might be fixed by re-setting selected cells array but this shortcut is safe.


  if (shouldExpandSelection || !isSelectionRectangular(selectedTableCells, tableUtils)) {
    // For a non-rectangular selection (ie in which some cells sticks out from a virtual selection rectangle) we need to create
    // a table layout that has a rectangular selection. This will split cells so the selection become rectangular.
    // Beyond this point we will operate on fixed content table.
    splitCellsToRectangularSelection(selectedTable, selection, writer);
  } // However a selected table fragment might be invalid if examined alone. Ie such table fragment:
  //
  //    +---+---+---+---+
  //  0 | a | b | c | d |
  //    +   +   +---+---+
  //  1 |   | e | f | g |
  //    +   +---+   +---+
  //  2 |   | h |   | i | <- last row, each cell has rowspan = 2,
  //    +   +   +   +   +    so we need to return 3, not 2
  //  3 |   |   |   |   |
  //    +---+---+---+---+
  //
  // is invalid as the cells "h" and "i" have rowspans.
  // This case needs only adjusting the selection dimension as the rest of the algorithm operates on empty slots also.
  else {
      selection.lastRow = adjustLastRowIndex(selectedTable, selection);
      selection.lastColumn = adjustLastColumnIndex(selectedTable, selection);
    }

  return selection;
} // Expand table (in place) to expected size.


function expandTableSize(table, expectedHeight, expectedWidth, tableUtils) {
  var tableWidth = tableUtils.getColumns(table);
  var tableHeight = tableUtils.getRows(table);

  if (expectedWidth > tableWidth) {
    tableUtils.insertColumns(table, {
      at: tableWidth,
      columns: expectedWidth - tableWidth
    });
  }

  if (expectedHeight > tableHeight) {
    tableUtils.insertRows(table, {
      at: tableHeight,
      rows: expectedHeight - tableHeight
    });
  }
} // Returns two-dimensional array that is addressed by [ row ][ column ] that stores cells anchored at given location.
//
// At given row & column location it might be one of:
//
// * cell - cell from pasted table anchored at this location.
// * null - if no cell is anchored at this location.
//
// For instance, from a table below:
//
//		+----+----+----+----+
//		| 00 | 01 | 02 | 03 |
//		+    +----+----+----+
//		|    | 11      | 13 |
//		+----+         +----+
//		| 20 |         | 23 |
//		+----+----+----+----+
//
// The method will return an array (numbers represents cell element):
//
//	const map = [
//		[ '00', '01', '02', '03' ],
//		[ null, '11', null, '13' ],
//		[ '20', null, null, '23' ]
//	]
//
// This allows for a quick access to table at give row & column. For instance to access table cell "13" from pasted table call:
//
//		const cell = map[ 1 ][ 3 ]
//


function createLocationMap(table, width, height) {
  // Create height x width (row x column) two-dimensional table to store cells.
  var map = new Array(height).fill(null).map(function () {
    return new Array(width).fill(null);
  });

  var _iterator3 = _createForOfIteratorHelper(new TableWalker(table)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref2 = _step3.value;
      var column = _ref2.column;
      var row = _ref2.row;
      var cell = _ref2.cell;
      map[row][column] = cell;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return map;
} // Make selected cells rectangular by splitting the cells that stand out from a rectangular selection.
//
// In the table below a selection is shown with "::" and slots with anchor cells are named.
//
// +----+----+----+----+----+                    +----+----+----+----+----+
// | 00 | 01 | 02 | 03      |                    | 00 | 01 | 02 | 03      |
// +    +----+    +----+----+                    |    ::::::::::::::::----+
// |    | 11 |    | 13 | 14 |                    |    ::11 |    | 13:: 14 |    <- first row
// +----+----+    +    +----+                    +----::---|    |   ::----+
// | 20 | 21 |    |    | 24 |   select cells:    | 20 ::21 |    |   :: 24 |
// +----+----+    +----+----+     11 -> 33       +----::---|    |---::----+
// | 30      |    | 33 | 34 |                    | 30 ::   |    | 33:: 34 |    <- last row
// +         +    +----+    +                    |    ::::::::::::::::    +
// |         |    | 43 |    |                    |         |    | 43 |    |
// +----+----+----+----+----+                    +----+----+----+----+----+
//                                                      ^          ^
//                                                     first & last columns
//
// Will update table to:
//
//                       +----+----+----+----+----+
//                       | 00 | 01 | 02 | 03      |
//                       +    +----+----+----+----+
//                       |    | 11 |    | 13 | 14 |
//                       +----+----+    +    +----+
//                       | 20 | 21 |    |    | 24 |
//                       +----+----+    +----+----+
//                       | 30 |    |    | 33 | 34 |
//                       +    +----+----+----+    +
//                       |    |    |    | 43 |    |
//                       +----+----+----+----+----+
//
// In th example above:
// - Cell "02" which have `rowspan = 4` must be trimmed at first and at after last row.
// - Cell "03" which have `rowspan = 2` and `colspan = 2` must be trimmed at first column and after last row.
// - Cells "00", "03" & "30" which cannot be cut by this algorithm as they are outside the trimmed area.
// - Cell "13" cannot be cut as it is inside the trimmed area.


function splitCellsToRectangularSelection(table, dimensions, writer) {
  var firstRow = dimensions.firstRow,
      lastRow = dimensions.lastRow,
      firstColumn = dimensions.firstColumn,
      lastColumn = dimensions.lastColumn;
  var rowIndexes = {
    first: firstRow,
    last: lastRow
  };
  var columnIndexes = {
    first: firstColumn,
    last: lastColumn
  }; // 1. Split cells vertically in two steps as first step might create cells that needs to split again.

  doVerticalSplit(table, firstColumn, rowIndexes, writer);
  doVerticalSplit(table, lastColumn + 1, rowIndexes, writer); // 2. Split cells horizontally in two steps as first step might create cells that needs to split again.

  doHorizontalSplit(table, firstRow, columnIndexes, writer);
  doHorizontalSplit(table, lastRow + 1, columnIndexes, writer, firstRow);
}

function doHorizontalSplit(table, splitRow, limitColumns, writer) {
  var startRow = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // If selection starts at first row then no split is needed.
  if (splitRow < 1) {
    return;
  }

  var overlappingCells = getVerticallyOverlappingCells(table, splitRow, startRow); // Filter out cells that are not touching insides of the rectangular selection.

  var cellsToSplit = overlappingCells.filter(function (_ref3) {
    var column = _ref3.column,
        cellWidth = _ref3.cellWidth;
    return isAffectedBySelection(column, cellWidth, limitColumns);
  });
  return cellsToSplit.map(function (_ref4) {
    var cell = _ref4.cell;
    return splitHorizontally(cell, splitRow, writer);
  });
}

function doVerticalSplit(table, splitColumn, limitRows, writer) {
  // If selection starts at first column then no split is needed.
  if (splitColumn < 1) {
    return;
  }

  var overlappingCells = getHorizontallyOverlappingCells(table, splitColumn); // Filter out cells that are not touching insides of the rectangular selection.

  var cellsToSplit = overlappingCells.filter(function (_ref5) {
    var row = _ref5.row,
        cellHeight = _ref5.cellHeight;
    return isAffectedBySelection(row, cellHeight, limitRows);
  });
  return cellsToSplit.map(function (_ref6) {
    var cell = _ref6.cell,
        column = _ref6.column;
    return splitVertically(cell, column, splitColumn, writer);
  });
} // Checks if cell at given row (column) is affected by a rectangular selection defined by first/last column (row).
//
// The same check is used for row as for column.


function isAffectedBySelection(index, span, limit) {
  var endIndex = index + span - 1;
  var first = limit.first,
      last = limit.last;
  var isInsideSelection = index >= first && index <= last;
  var overlapsSelectionFromOutside = index < first && endIndex >= first;
  return isInsideSelection || overlapsSelectionFromOutside;
}